export default {
  返回上一页: "Back",
  密码规则说明:
    "Please enter a new password. The password must be 8-12 characters and contain both numbers and letters.",
  新密码: "New Password",
  密码必填提示: "8-12 characters, contains numbers and letters",
  密码格式提示:
    "Password must be 8-12 characters and contain both letters and numbers",
  确认密码: "Confirm Password",
  确认密码必填提示: "Please enter your password again",
  密码不一致提示: "The two passwords do not match",
  完成: "Complete",
  帐号验证: "Account Verification",
  重置密码: "Reset Password",
  安全通知已发送: "Security notification sent to:",
  登录邮箱提示: "Your login email:",
  立即登录: "Login Now",
  邮箱验证说明:
    "Please enter your login email address, and we will send a security verification code to your email.",
  无法访问邮箱说明:
    "If you cannot access your registered email, please contact customer service for assistance.",
  联系客服: "Contact Customer Service",
  员工工号: "Employee ID",
  请输入工号: "Please enter your employee ID!",
};
